import { render } from "./TransferChatConfiguration.vue?vue&type=template&id=1167ba31&scoped=true&lang=pug"
import script from "./TransferChatConfiguration.vue?vue&type=script&lang=js"
export * from "./TransferChatConfiguration.vue?vue&type=script&lang=js"

import "./TransferChatConfiguration.vue?vue&type=style&index=0&id=1167ba31&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1167ba31"]])

export default __exports__